import { useDebouncedEffect } from "@react-hookz/web";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { CloseIcon } from "~/components/ui/icons/close";
import { SearchIcon } from "~/components/ui/icons/search";

export const StockSearch = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState<string | null>(
    searchParams.get("q"),
  );
  useDebouncedEffect(
    () => {
      if (searchTerm) {
        setSearchParams((prev) => {
          prev.set("q", searchTerm);
          return prev;
        });
      } else {
        setSearchParams((prev) => {
          prev.delete("q");
          return prev;
        });
      }
    },
    [searchTerm],
    150,
  );

  return (
    <div className="relative w-full rounded text-[#767A7C] transition-colors duration-300 focus-within:text-gray-900 sm:border-b sm:border-gray-100">
      <div className="absolute inset-y-0 left-0 flex items-center pl-2 sm:pl-0 [&:has(~_:disabled)]:text-gray-300">
        <SearchIcon className="size-4" />
      </div>
      <input
        type="search"
        className="no-cancel-search form-input w-full rounded border px-8 pb-[0.44rem] pt-2 text-sm leading-5.5 text-gray-900 outline-none hover:border-gray-700 focus:border-gray-700 focus:ring-gray-700 sm:border-none sm:px-6 sm:focus:ring-transparent"
        placeholder={t("stock.search.placeholder")}
        value={searchTerm ?? ""}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {searchTerm ? (
        <div className="absolute inset-y-0 right-0 flex items-center pr-2 text-gray-900 sm:pr-0 [&:has(~_:disabled)]:text-gray-300">
          <button type="button" onClick={() => setSearchTerm("")}>
            <CloseIcon className="size-4" />
          </button>
        </div>
      ) : null}
    </div>
  );
};
